import classNames from "classnames";

/**
 * Shared class strings for the Menu's floating panel and rows — the single
 * source of truth for the Claude Design menu look. Other menu-like surfaces
 * (e.g. the table's filter-v2 dropdown, whose grammar the Menu was lifted
 * from) import these so the two stay pixel-consistent.
 */

export const MENU_PANEL_CLASSES = classNames(
  "z-[1000] min-w-[248px] p-1.5",
  "bg-white border border-gray-200 rounded-lg shadow-panel-lift",
  "font-sans",
  "motion-safe:data-[state=open]:animate-menu-in",
);

export const MENU_ITEM_CLASSES = classNames(
  "group flex items-center gap-2.5 rounded-md px-2.5 py-2",
  "text-sm leading-tight text-gray-700 select-none outline-none",
  "cursor-pointer transition-colors duration-100",
  "data-[highlighted]:bg-primary-50 data-[highlighted]:text-primary-700",
  "data-[disabled]:opacity-45 data-[disabled]:cursor-not-allowed",
);

export const MENU_DANGER_ITEM_CLASSES = classNames(
  "text-red-600",
  "data-[highlighted]:bg-red-50 data-[highlighted]:text-red-600",
);

export const MENU_ICON_SLOT_CLASSES = classNames(
  "w-5 h-5 shrink-0 grid place-items-center",
  "text-gray-400 transition-colors duration-100",
  "group-data-[highlighted]:text-primary-500",
);

export const MENU_DANGER_ICON_SLOT_CLASSES = classNames(
  "text-red-500 group-data-[highlighted]:text-red-500",
);

export const MENU_SEPARATOR_CLASSES = "h-px bg-gray-200 my-[5px] mx-1";

export const MENU_LABEL_CLASSES = classNames(
  "px-2.5 pt-2 pb-1",
  "text-[11px] font-semibold uppercase tracking-wider text-gray-400",
);
